import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  box-sizing: border-box;

  .circle {
    display: block;
    width: 20px;
    height: 20px;
    border: 2.6px solid ${(props) => props.theme.colors.grey};
    border-top: 2.6px solid ${(props) => props.theme.colors.secondary};
    border-radius: 50%;
    position: absolute;
    box-sizing: border-box;
    top: 0;
    left: 0;
  }
`;
